import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueGtm from 'vue-gtm'
import axios from 'axios'

import App from "./components/App.vue";
import Homepage from "./components/homepage/index.vue";
import Projects from "./components/projects/index.vue";
import Jobs from "./components/jobs/index.vue";
import Job from "./components/job/index.vue";
import Coworking from "./components/coworking/index.vue";
import Imprint from "./components/imprint/index.vue";
import Cookies from "./components/cookies/index.vue";

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.prototype.$axios = axios

const store = new Vuex.Store({
  state: {
    projects: [],
    services: [],
    jobs: [],
    contactModal: false,
    currentProject: []
  },
  mutations: {
    SET_SERVICES(state, services) {
      state.services = services
    },
    SET_PROJECTS(state, projects) {
      state.projects = projects
    },
    SET_JOBS(state, jobs) {
      state.jobs = jobs
    },
    SET_CONTACTMODAL(state, modal) {
      state.contactModal = modal
    }
  },
  getters: {},
  actions: {
    fetchProjects(context) {
      axios.get("/data/projects.json").then((response) => {
        context.commit('SET_PROJECTS', response.data)
      })
    },
    fetchServices(context) {
      axios.get("/data/services.json").then((response) => {
        context.commit('SET_SERVICES', response.data)
      })
    },
    fetchJobs(context) {
      axios.get("/data/jobs.json").then((response) => {
        context.commit('SET_JOBS', response.data)
      })
    }
  }
})

const router = new VueRouter({
  routes: [{
      path: "/",
      component: Homepage
    }, {
      path: "/projects",
      name: "projects",
      component: Projects
    },
    {
      path: '/projects/:projectId',
      name: 'project',
      component: Projects
    },
    {
      path: '/coworking',
      component: Coworking
    }, {
      path: "/imprint",
      component: Imprint
    }, {
      path: "/cookies",
      component: Cookies
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: Jobs
    },
    {
      path: '/jobs/:jobId',
      name: 'job',
      component: Job
    },
  ],
  mode: "history",
  scrollBehavior() {
        return {x: 0, y: 0}
    }
});

Vue.use(VueGtm, {
  id: 'GTM-PTQFD3L', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional
});

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
}).$mount('#app')